import { ArrowRightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import Page from '../../Components/Page/Page';
import { TextService } from '../../Services/TextService';
import { Checks, Crumbs, CtaBanner, Hero, IntegrationsStrip, LogoPanel, SectionHead, Shot, Split, useScrollTop } from '../Start2/Marketing2';
import '../Start2/Start2.css';

// SEO article for /betalintegrationer, built from the shared Start2 marketing components.
// "Betalningspåminnelser" under Ping Payments is left out since we could not verify it.
const MemberSystemIntegrations = () => {
  const GetText = TextService.GetText;
  useScrollTop();

  return <Page className='start2' pageTitle={GetText("PageTitle_Integrations")} metaDescription="Integrera ditt medlemsregister med Fortnox, Spiris och betallösningar. OneFront360 kopplar ihop dina system.">

    <Hero
      crumb={<Crumbs current="Betalintegrationer" />}
      title="Betalintegrationer för föreningar – automatiserat, säkert och utan manuellt arbete"
      lead="Ta emot medlemsavgifter och eventbetalningar via Swish, kort och faktura med Ping Payments – med full synk mot Fortnox och Spiris."
      image={require('../../Images/Articles/betalintegrationer.png')}
      imageAlt="Illustration av betalintegrationer i OneFront360"
    />

    <IntegrationsStrip title="Fungerar med" />

    <section className="s2-section s2-bg-soft">
      <div className="s2-container">
        <SectionHead
          title="Smarta integrationer för en effektivare förening"
          text="När dina verktyg pratar med varandra slipper du dubbelarbete, manuella rutiner och risken för fel. OneFront360 kopplar ihop medlemssystemet med hemsida, betalningslösningar och ekonomisystem." />
        <div className="s2-cards">
          <div className="s2-card"><span className="s2-numbered">1</span><h3>Hemsidan</h3><p>Smidiga medlemsregistreringar direkt från föreningens webbplats.</p></div>
          <div className="s2-card"><span className="s2-numbered">2</span><h3>Betalningar</h3><p>Automatisera medlemsinbetalningar via Ping Payments.</p></div>
          <div className="s2-card"><span className="s2-numbered">3</span><h3>Ekonomi</h3><p>Synkronisera ekonomi och fakturor med Fortnox, Spiris, ...</p></div>
        </div>
      </div>
    </section>

    <section className="s2-section">
      <div className="s2-container">
        <Split eyebrow="Ping Payments" title="Automatiserade och säkra betalningar" visual={<LogoPanel img={require('../../Images/pingpayments.png')} alt="Ping Payments" tint="blue" />}>
          <p>OneFront360 har en direkt integration med <strong>Ping Payments</strong>, en svensk betalningsplattform utvecklad för organisationer och föreningar. Ta emot medlemsavgifter och eventbetalningar via Swish, kort eller faktura – helt automatiserat.</p>
          <Checks items={[
            "Betalningar registreras automatiskt i medlemsregistret",
            "Stöd för Swish, kort och faktura",
            "Full överblick över betalda och obetalda avgifter",
          ]} />
        </Split>

        <Split reverse eyebrow="Fortnox" title="Sömlös synk av ekonomi och bokföring" visual={<LogoPanel img={require('../../Images/fortnox.png')} alt="Fortnox" tint="green" />}>
          <p>Använder föreningen <strong>Fortnox</strong>? Fakturor och betalningar i Fortnox läses in till OneFront360 automatiskt, så att årsavgiften prickas av i medlemsregistret utan manuellt arbete.</p>
          <Checks items={[
            "Betalningar från Fortnox prickar av medlemsavgifter automatiskt",
            "Synkat kundregister och artiklar mellan Fortnox och OneFront360",
            "Skapa fakturautkast i Fortnox för flera medlemmar samtidigt",
          ]} />
          <p><Link to="/se/fortnox-integration" className="s2-more">Läs mer om Fortnox-integrationen <ArrowRightOutlined /></Link></p>
        </Split>

        <Split eyebrow="Spiris" title="Sömlös synk av ekonomi och bokföring" visual={<LogoPanel img={require('../../Images/spiris.png')} alt="Spiris" tint="orange" />}>
          <p>Använder föreningen <strong>Spiris</strong> (tidigare Visma Spcs)? Fakturor och betalningar i Spiris läses in till OneFront360 automatiskt, så att årsavgiften prickas av i medlemsregistret utan manuellt arbete.</p>
          <Checks items={[
            "Betalningar från Spiris prickar av medlemsavgifter automatiskt",
            "Synkat kundregister och artiklar mellan Spiris och OneFront360",
            "Skapa fakturautkast i Spiris för flera medlemmar samtidigt",
          ]} />
          <p><Link to="/se/spiris-integration" className="s2-more">Läs mer om Spiris-integrationen <ArrowRightOutlined /></Link></p>
        </Split>

        <Split reverse eyebrow="Hemsidan" title="Smidiga flöden för medlemmar" visual={<Shot src={require('../../Images/Articles/ny-medlem.png')} alt="Formulär för ny medlem i OneFront360" />}>
          <p>Nya medlemmar kan registrera sig online, anmäla sig till aktiviteter och betala direkt – och all information hamnar automatiskt i systemet.</p>
          <Checks items={[
            "Medlemsregistrering direkt på hemsidan",
            "Automatisk import till medlemsregistret",
            "Integrera eventanmälningar direkt på hemsidan",
            "Mindre administration för föreningen",
          ]} />
        </Split>
      </div>
    </section>

    <CtaBanner />
  </Page>
};

export default MemberSystemIntegrations;
